/* AKLAIR theme behaviour: scroll motion, modals, quick add, pre-checkout upsell */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motion = !reduce && window.gsap && window.ScrollTrigger;
  const triggers = new WeakMap(); // section -> [ScrollTrigger | timeline]

  function headerHeight() {
    const h = $('#AkNav');
    document.documentElement.style.setProperty('--ak-header-h', (h ? h.offsetHeight : 0) + 'px');
  }

  /* ---------- modals ---------- */
  function openModal(m) { if (!m) return; m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.classList.add('overflow-hidden'); const f = m.querySelector('[data-ak-focus]') || m.querySelector('button'); f && f.focus(); }
  function closeModal(m) { if (!m) return; m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); document.body.classList.remove('overflow-hidden'); const v = m.querySelector('video'); v && v.pause(); }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ak-open]');
    if (opener) { const m = document.getElementById(opener.dataset.akOpen); openModal(m); const v = m && m.querySelector('video'); v && v.play().catch(() => {}); return; }
    const closer = e.target.closest('[data-ak-close]');
    if (closer) { closeModal(closer.closest('.ak-modal')); return; }
    if (e.target.classList && e.target.classList.contains('ak-modal')) closeModal(e.target);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.ak-modal.is-open').forEach(closeModal); });

  /* ---------- quick add to cart (opens Dawn's drawer) ---------- */
  async function addToCart(variantId, btn, sellingPlan) {
    const drawer = $('cart-drawer');
    btn && (btn.disabled = true);
    try {
      const item = { id: Number(variantId), quantity: 1 };
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      const body = { items: [item] };
      if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add to bag');
      if (drawer && data.sections) drawer.renderContents(data);
      else location.href = (window.routes && window.routes.cart_url) || '/cart';
    } catch (err) {
      alert(err.message);
    } finally { btn && (btn.disabled = false); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.ak-add[data-variant-id]');
    if (!b) return;
    e.preventDefault();
    const card = b.closest('.ak-card');
    const plan = card && card.dataset.subOn === '1' ? $('[data-ak-plan]', card)?.value : null;
    addToCart(b.dataset.variantId, b, plan);
  });

  /* ---------- pre-checkout upsell ---------- */
  let upsellPassed = false;
  async function maybeUpsell(e) {
    const btn = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    const modal = $('#AkUpsell');
    if (!btn || !modal || upsellPassed) return;
    const offers = JSON.parse(modal.dataset.offers || '[]');
    if (!offers.length) return;
    e.preventDefault(); e.stopPropagation();
    let cart;
    try { cart = await fetch('/cart.js').then((r) => r.json()); } catch (_) { return goCheckout(); }
    const inCart = new Set(cart.items.map((i) => String(i.product_id)));
    const offer = offers.find((o) => !inCart.has(String(o.product_id)));
    if (!offer) return goCheckout();
    $('[data-ak-up-img]', modal).src = offer.image;
    $('[data-ak-up-img]', modal).alt = offer.title;
    $('[data-ak-up-title]', modal).textContent = offer.heading;
    $('[data-ak-up-text]', modal).textContent = offer.text;
    $('[data-ak-up-price]', modal).textContent = offer.price;
    modal.dataset.variant = offer.variant_id;
    openModal(modal);
  }
  function goCheckout() { upsellPassed = true; location.href = '/checkout'; }
  document.addEventListener('click', maybeUpsell, true);
  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-ak-up-yes]')) {
      const m = $('#AkUpsell'); const b = e.target.closest('button'); b.disabled = true;
      try {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(m.dataset.variant), quantity: 1 }] }) });
      } catch (_) {}
      goCheckout();
    }
    if (e.target.closest('[data-ak-up-no]')) goCheckout();
  });

  /* ---------- per-section init ---------- */
  function kill(section) { (triggers.get(section) || []).forEach((t) => t && t.kill && t.kill()); triggers.set(section, []); }
  function keep(section, t) { const a = triggers.get(section) || []; a.push(t); triggers.set(section, a); return t; }

  function setSub(section, on) {
    $$('.ak-sub-toggle button', section).forEach((x) => x.setAttribute('aria-pressed', String((x.dataset.sub === '1') === on)));
    $$('.ak-card', section).forEach((card) => {
      const canSub = !!$('[data-ak-plan]', card);
      const sub = on && canSub;
      card.dataset.subOn = sub ? '1' : '0';
      $$('[data-sub]', card).forEach((el) => (el.hidden = !sub));
      $$('[data-once]', card).forEach((el) => (el.hidden = sub));
    });
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('.ak-sub-toggle button');
    if (t) setSub(t.closest('.ak-shop'), t.dataset.sub === '1');
  });

  const inits = {
    shop(s) {
      const on = $('.ak-sub-toggle button[data-sub="1"]', s);
      setSub(s, !!on && on.getAttribute('aria-pressed') === 'true');
    },
    hero(s) {
      if (!motion) return;
      const product = $('.ak-hero__product', s), stage = $('.ak-hero__stage', s), glow = $('.ak-hero__glow', s);
      gsap.from(product, { y: 180, opacity: 0, duration: 1.6, ease: 'expo.out', delay: .15 });
      gsap.from(stage.children, { y: 40, opacity: 0, duration: 1.2, stagger: .09, ease: 'expo.out' });
      keep(s, gsap.timeline({ scrollTrigger: { trigger: s, start: 'top top', end: '+=120%', scrub: true, pin: true } })
        .to(stage, { y: -120, opacity: 0, ease: 'none' }, 0)
        .to(product, { y: '-58vh', scale: 1.35, ease: 'none' }, 0)
        .to(glow, { scale: 1.6, opacity: .6, ease: 'none' }, 0));
    },
    statement(s) {
      const q = $('.ak-statement__q', s);
      if (!q.dataset.split) { q.innerHTML = q.textContent.trim().split(/\s+/).map((w) => `<span class="w">${w}</span>`).join(' '); q.dataset.split = '1'; }
      const words = $$('.w', q);
      if (!motion) { words.forEach((w) => (w.style.opacity = 1)); return; }
      keep(s, gsap.to(words, { opacity: 1, stagger: .5, ease: 'none', scrollTrigger: { trigger: s, start: 'top 70%', end: 'bottom 60%', scrub: true } }));
    },
    founder(s) {
      if (!motion) return;
      keep(s, gsap.fromTo($('.ak-founder__media', s), { clipPath: 'inset(12% 16% 12% 16% round 28px)', scale: .96 },
        { clipPath: 'inset(0% 0% 0% 0% round 14px)', scale: 1, ease: 'none', scrollTrigger: { trigger: s, start: 'top 85%', end: 'top 25%', scrub: true } }));
    },
    band(s) {
      if (!motion) return;
      const frame = $('.ak-band__frame', s), mobile = () => innerWidth < 760;
      keep(s, gsap.timeline({ scrollTrigger: { trigger: s, start: 'top top', end: '+=110%', scrub: true, pin: $('.ak-band__pin', s), invalidateOnRefresh: true } })
        .to(frame, { clipPath: () => (mobile() ? 'inset(28% 0% 0% 0% round 0px)' : 'inset(30% 4% 4% 4% round 14px)'), ease: 'none' }, 0)
        .to($$('img', frame), { scale: 1, ease: 'none' }, 0)
        .fromTo($$('.ak-band__side', frame), { opacity: 0 }, { opacity: 1, ease: 'none', duration: .6 }, .2)
        .fromTo($('.ak-band__copy', s), { y: 40, opacity: 0 }, { y: 0, opacity: 1, ease: 'none', duration: .35 }, 0));
    },
    ritual(s) {
      const steps = $$('.ak-step', s), imgs = $$('.ak-ritual__visual img', s), bars = $$('.ak-progress b', s), label = $('.ak-progress span', s);
      const tints = (s.dataset.tints || '').split(',');
      const n = steps.length; let cur = 0;
      const set = (i) => {
        if (i === cur) return; cur = i;
        steps.forEach((x, k) => x.classList.toggle('is-on', k === i));
        imgs.forEach((x, k) => x.classList.toggle('is-on', k === i));
        if (tints[i]) s.style.background = tints[i];
        if (label) label.textContent = `${i + 1} / ${n}`;
      };
      if (!motion || n < 2) {
        // Without motion every step stays readable, stacked.
        if (!motion) { steps.forEach((x) => { x.classList.add('is-on'); x.style.position = 'relative'; }); $('.ak-ritual__copy', s).style.minHeight = 'auto'; }
        return;
      }
      keep(s, ScrollTrigger.create({ trigger: s, start: 'top top', end: `+=${n * 80}%`, pin: true, scrub: true,
        onUpdate: (self) => { const p = self.progress * n; set(Math.min(n - 1, Math.floor(p))); bars.forEach((b, k) => (b.style.transform = `scaleX(${Math.max(0, Math.min(1, p - k))})`)); } }));
    },
    ingredients(s) {
      if (!motion) return;
      const it = gsap.timeline({ scrollTrigger: { trigger: s, start: 'top top', end: '+=180%', scrub: true, pin: $('.ak-ingr__pin', s) } });
      it.fromTo($('.ak-ingr__bottle', s), { y: 160, scale: .85 }, { y: 0, scale: 1, ease: 'none', duration: 1 }, 0)
        .fromTo($$('.ak-halo', s), { scale: .4, opacity: 0 }, { scale: 1, opacity: 1, stagger: .2, ease: 'none', duration: 1 }, 0);
      $$('.ak-chip', s).forEach((c, k) => it.fromTo(c, { opacity: 0, y: 16 }, { opacity: 1, y: 0, ease: 'power2.out', duration: .5 }, .6 + k * .35));
      keep(s, it);
    },
    gallery(s) {
      if (!motion) return;
      const track = $('.ak-gallery__track', s);
      const dist = () => Math.max(0, track.scrollWidth - innerWidth + 48);
      keep(s, gsap.to(track, { x: () => -dist(), ease: 'none', scrollTrigger: { trigger: s, start: 'top top', end: () => '+=' + dist(), scrub: true, pin: $('.ak-gallery__pin', s), invalidateOnRefresh: true } }));
    },
    results(s) {
      const ba = $('.ak-ba', s); if (!ba) return;
      const range = $('input', ba);
      range.addEventListener('input', () => ba.style.setProperty('--x', range.value + '%'));
      if (!motion) return;
      keep(s, ScrollTrigger.create({ trigger: ba, start: 'top 70%', once: true, onEnter: () => {
        const o = { x: 85 };
        gsap.to(o, { x: 50, duration: 1.6, ease: 'expo.out', onUpdate: () => { ba.style.setProperty('--x', o.x + '%'); range.value = o.x; } });
      } }));
    }
  };

  function reveal(root) {
    if (!motion) return;
    ScrollTrigger.batch($$('[data-ak-reveal]', root), { start: 'top 88%', once: true,
      onEnter: (b) => gsap.fromTo(b, { y: 34, opacity: .35 }, { y: 0, opacity: 1, duration: 1, stagger: .08, ease: 'expo.out', clearProps: 'transform,opacity' }) });
  }

  function initSection(s) {
    const kind = s.dataset.akSection;
    if (!inits[kind]) return;
    kill(s);
    inits[kind](s);
  }

  function initAll(root = document) {
    headerHeight();
    $$('[data-ak-section]', root).forEach(initSection);
    reveal(root);
    motion && ScrollTrigger.refresh();
    navState();
  }

  /* header: solid once the pinned hero has scrolled away; sticky buy bar on phones */
  function navState() {
    const nav = $('#AkNav'), hero = $('.ak-hero'), sticky = $('.ak-sticky');
    const y = window.scrollY;
    if (nav && nav.hasAttribute('data-transparent')) {
      const heroEnd = hero ? hero.getBoundingClientRect().bottom + y - (nav.offsetHeight || 80) : 0;
      nav.classList.toggle('is-solid', y > heroEnd || !hero);
    }
    if (sticky) sticky.classList.toggle('is-on', y > innerHeight * 1.2);
  }
  addEventListener('scroll', navState, { passive: true });

  if (motion) {
    gsap.registerPlugin(ScrollTrigger); document.documentElement.classList.add('ak-js');
    // Images without fixed sizes change the layout as they load; re-measure the pins.
    let t; const refresh = () => { clearTimeout(t); t = setTimeout(() => ScrollTrigger.refresh(), 150); };
    addEventListener('load', refresh);
    document.addEventListener('load', (e) => { if (e.target.tagName === 'IMG') refresh(); }, true);
    ScrollTrigger.addEventListener('refresh', navState);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  addEventListener('resize', headerHeight, { passive: true });

  // Theme editor: re-run a section when it is edited or reordered.
  document.addEventListener('shopify:section:load', (e) => { const s = $('[data-ak-section]', e.target); if (s) { initSection(s); reveal(e.target); motion && ScrollTrigger.refresh(); } });
  document.addEventListener('shopify:section:unload', (e) => { const s = $('[data-ak-section]', e.target); if (s) kill(s); });
  document.addEventListener('shopify:section:reorder', () => motion && ScrollTrigger.refresh());
})();
